<div class="modal-overlay" (click)="fecharModal()">
  <div class="box-nova-tarefa" (click)="$event.stopPropagation()">
    <div class="row">
      <div class="col-md-6">
        <h5 class="fw-bold">
          <i class="fa fa-plus-circle"></i> {{ titulo }}
        </h5>
      </div>
      <div class="col-md-6 text-end">
        <button type="button" class="btn-close" (click)="fecharModal()" aria-label="Close"></button>
      </div>
    </div>
    <hr>

    <div class="row g-3">
      <div class="col-md-6">
        <label for="mesOrcamento" class="form-label">Mês</label>
        <ng-select [items]="listaMeses"
                   bindLabel="descricao"
                   bindValue="id"
                   [(ngModel)]="orcamento.mes"
                   [clearable]="false"
                   [ngClass]="{'is-invalid': errors.mes}"
                   id="mesOrcamento">
        </ng-select>
        <span class="error mensagem-erro" *ngIf="errors.mes">O mês é obrigatório</span>
      </div>

      <div class="col-md-6">
        <label for="semanaOrcamento" class="form-label">Semana</label>
        <ng-select [items]="semanas"
                   bindLabel="descricao"
                   bindValue="id"
                   [(ngModel)]="orcamento.semana"
                   [clearable]="false"
                   [ngClass]="{'is-invalid': errors.semana}"
                   id="semanaOrcamento">
        </ng-select>
        <span class="error mensagem-erro" *ngIf="errors.semana">A semana é obrigatória</span>
      </div>

      <div class="col-md-6">
        <label for="tipoOrcamento" class="form-label">{{ labelTipo }}</label>
        <ng-select [items]="tipos"
                   [(ngModel)]="orcamento.tipoConta"
                   *ngIf="orcamento.tipoConta !== undefined"
                   [clearable]="false"
                   [ngClass]="{'is-invalid': errors.tipo}"
                   id="tipoOrcamento">
        </ng-select>
        <ng-select [items]="tipos"
                   [(ngModel)]="orcamento.tipoReceita"
                   *ngIf="orcamento.tipoReceita !== undefined"
                   [clearable]="false"
                   [ngClass]="{'is-invalid': errors.tipo}"
                   id="tipoOrcamentoReceita">
        </ng-select>
        <span class="error mensagem-erro" *ngIf="errors.tipo">O tipo é obrigatório</span>
      </div>

      <div class="col-md-6">
        <label for="valorOrcamento" class="form-label">Valor</label>
        <input type="text" class="form-control" name="valorOrcamento" id="valorOrcamento" [(ngModel)]="orcamento.valor"
               mask="separator.2" prefix="R$ " thousandSeparator="." decimalMarker="," [dropSpecialCharacters]="true"
               [ngClass]="{'is-invalid': errors.valor}">
        <span class="error mensagem-erro" *ngIf="errors.valor">O valor é obrigatório</span>
      </div>

      <div class="col-md-12 d-flex justify-content-end gap-2 mt-4">
        <button *ngIf="modoEdicao" type="button" class="btn btn-outline-danger me-auto" (click)="excluirOrcamento()">
          <i class="fa fa-trash"></i> Excluir
        </button>
        <button type="button" class="btn btn-light" (click)="fecharModal()">Cancelar</button>
        <button type="button" class="btn btn-primary px-4 d-flex align-items-center gap-2" (click)="salvarOrcamento()" [disabled]="!orcamento.mes || !orcamento.semana || (!orcamento.tipoConta && !orcamento.tipoReceita) || !orcamento.valor">
          Salvar
        </button>
      </div>
    </div>
  </div>
</div>
